import EventEmitter from "@elsa-zku/lib/helpers/EventEmitter";
import randomString from "@elsa-zku/lib/helpers/randomString";
import { scrollTo } from "@elsa-zku/lib/helpers/scrollTo";
import qs from "qs";
import * as React from "react";

export const DISABLE_NOTIFICATIONS_FILTER_TOP_ID = randomString(10);

// https://github.com/nanostores/router/blob/main/index.js

export type DisableNotificationsFilter = {
  building_id: number,
  search: string,
  year: number
};

let _lastFilter: DisableNotificationsFilter;
const filterEmitter = new EventEmitter();

export const parseDisableNotificationsFilter = (locationSearch?: string) => {
  const query = qs.parse(locationSearch || location.search.substring(1));
  const { building_id, search, year } = query;
  const filter: DisableNotificationsFilter = {
    building_id: null,
    search:      undefined,
    year:        undefined,
  };
  if (+building_id) filter.building_id = +building_id;
  if (typeof search === 'string' && search.length) filter.search = search;
  if (+year) filter.year = +year;

  _lastFilter = filter;
  filterEmitter.emit('filter', _lastFilter);
  return filter;
}

export const stringifyDisableNotificationsFilter = (newFilter: Partial<DisableNotificationsFilter>) => {
  return qs.stringify({ ..._lastFilter, ...newFilter });
}

export const getDisableNotificationsHref = (newFilter: string) => {
  return `${window.location.pathname}?${newFilter}`
}

export const onClickDisableNotificationsLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
  let link = event.currentTarget;
  if (isRouterClick(event, link)) {
    if (link.pathname === location.pathname && link.hash === location.hash) {
      event.preventDefault();
      navigateDisableNotifications(link.search.substring(1));
    }
  }
}

export const useDisableNotificationsFilter = () => {
  const [filter, setFilter] = React.useState<DisableNotificationsFilter>();

  React.useEffect(() => {
    const listener = filterEmitter.on('filter', (filter: DisableNotificationsFilter) => setFilter(filter))
    setFilter(_lastFilter);
    return () => {
      listener();
    }
  }, []);

  return filter;
}

export const navigateDisableNotifications = (newFilter: string) => {
  history.pushState(null, null, getDisableNotificationsHref(newFilter));
  parseDisableNotificationsFilter(newFilter);
  scrollTo(document.getElementById(DISABLE_NOTIFICATIONS_FILTER_TOP_ID));
}

export const useDisableNotificationsFilterWatcher = () => {
  React.useEffect(() => {
    let popstate = () => parseDisableNotificationsFilter();
    popstate();
    window.addEventListener('popstate', popstate);
    return () => {
      window.removeEventListener('popstate', popstate);
    }
  }, []);

}

function isRouterClick(event: React.MouseEvent<HTMLAnchorElement>, link: HTMLAnchorElement) {
  return (
    link &&
    event.button === 0 && // Left mouse button
    link.target !== '_blank' && // Not for new tab
    link.origin === location.origin && // Not external link
    link.rel !== 'external' && // Not external link
    link.target !== '_self' && // Now manually disabled
    !link.download && // Not download link
    !event.altKey && // Not download link by user
    !event.metaKey && // Not open in new tab by user
    !event.ctrlKey && // Not open in new tab by user
    !event.shiftKey && // Not open in new window by user
    !event.defaultPrevented // Click was not cancelled
  )
}